import Modal from "../../../../../commons/Modal/Modal";
import AddSubUserForm from "./AddSubUserENTForm/AddSubUserENTForm";
import { AddSubUserModalProps } from "./AddSubUserENTModal.types";

export default (props: AddSubUserModalProps) => {

  return (
    <Modal closeOnClickOutside {...props}>
      <AddSubUserForm />
    </Modal>
  )
}